export const environment = {
  production: false,
  // api: "http://200.55.245.33:3002/api/", //VM VIEJA DE BRIKET DENTRO DE INS
  // api: "http://localhost:3002/api/",  // LOCALHOST
  // api: "http://4.228.48.28:3002/api/",  // PROD
  api: "http://postventa.briket.com.ar:3002/api/",  // PROD
};
